import React, { useState } from "react";
import styles from "./club.module.css";
import { TG, STACK_TOPIC_TO_STACK_ID } from "../../../constants";
import lineImage from "../../../assets/images/line.jpg";
import { ImageLightbox } from "../../image-lightbox/image-lightbox";
import { EventTimelineChart } from "./graph";
import { ReactComponent as BrainLogo } from "../../../assets/images/icon.svg";

export const SectionClub = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();

    const href = e.currentTarget.getAttribute("href");
    const id = href.slice(1);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleTopicClick = (e, topicId) => {
    e.preventDefault();
    e.stopPropagation();

    // Scroll to corresponding stack element using mapping
    const stackId = STACK_TOPIC_TO_STACK_ID[topicId] || topicId;
    const stackElement = document.querySelector(`[data-stack-topic="${stackId}"]`);
    if (stackElement) {
      stackElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    // Close lightbox if it's open
    if (lightboxOpen) {
      setLightboxOpen(false);
    }

    // Update active topic
    
  };

  return (
    <>
      <section className={styles.sectionClubContainer} id="club">
        <h1 className={styles.title}>
          Серьёзные последствия
          <br />

          <span className={styles.subtitle}>
            <span className={styles.subtitleText}>для </span>
            <span className={styles.subtitleHighlight}>
              <span className={styles.glowText}>мышления</span>
            <svg className={styles["icon-thinking"]} viewBox="64 64 896 896" focusable="false" fill="currentColor">
              <path d="M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0034.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm96 600a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm408-491a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" />
            </svg>
            </span>
            <br className={styles.subtitleBreak} />
            <span className={styles.subtitleText}>и   </span>
            <span className={styles.subtitleHighlight}>
              <span className={styles.glowText}>зрения</span>
              <svg className={styles["icon-green"]} viewBox="64 64 896 896" focusable="false" fill="currentColor">
                <path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" />
              </svg>
            </span>
          </span>

        </h1>
        <div className={styles.heroSection}>
          <div className={styles.sectionClub}>
            <article className={styles.infoPanel}>
              <div className={styles.cardScanline} aria-hidden="true" />
              <div className={styles.cardCornerTL} aria-hidden="true" />
              <div className={styles.cardCornerBR} aria-hidden="true" />
              <blockquote className={styles.cite}>
                <p> — А что же мы с вами? Как подумаешь о будущем… Продолжать ли нам опыты?</p>
                <p> — Продолжать ли? Обязательно продолжать! Что же мы с тобой иначе станем делать? Карамельки, что ли, сосать между завтраком и обедом?..</p>
                <p> — Серьёзные последствия! — продолжал он после небольшой паузы. — Ну, конечно, серьёзные последствия! Обязательно! Из-за чего же иначе работать, как не из-за серьёзных последствий? В кои-то веки в наши руки попала возможность добиться серьезных последствий, а вы намерены отступать?</p>
                <footer>Герберт Уэллс, «Пища богов»</footer>
              </blockquote>
            </article> 
            <div className={styles.stackContainer}>
              <p className={styles.stackParagraph}>Тематики книжного клуба:</p>
              <div className={styles.itemStackContainer}>
                <div
                  className={styles.itemStack}
                  onClick={(e) => handleTopicClick(e, "будущее-и-мы-в-нём")}
                >Будущее и мы в нём</div>
                <div
                  className={styles.itemStack}
                  onClick={(e) => handleTopicClick(e, "человек-и-его-голова")}
                >Человек и его голова</div>
                <div
                  className={styles.itemStack}
                  onClick={(e) => handleTopicClick(e, "неподъёмные-произведения")}
                >Неподъёмные произведения</div>
                <div
                  className={styles.itemStack}
                  onClick={(e) => handleTopicClick(e, "хиханьки-хаханьки")}
                >Хиханьки-хаханьки</div>
                <div
                  className={styles.itemStack}
                  onClick={(e) => handleTopicClick(e, "заезженное-под-новым-углом")}
                >Заезженное под новым углом</div>
              </div>
            </div>
            <div className={styles.portfolioWrap}>
              <a
                href="#portfolio"
                className={`${styles.tierButton} ${styles.tierButtonPink}`}
                onClick={handleClick}
              >
                <BrainLogo style={{ width: "20px", height: "20px", filter: "brightness(0) invert(1)", flexShrink: 0 }} />
                <span className={styles.tierButtonText}>Разобранное</span>
                <span className={styles.tierButtonArrow} aria-hidden="true">→</span>
              </a>
              <a
                href={TG.link}
                className={`${styles.tierButton} ${styles.tierButtonBlue}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.108 7.617C5.4 5.768 8.262 4.55 9.694 3.961c4.088-1.682 4.938-1.974 5.492-1.984.68-.011.86.551.804 1.137-.221 2.302-1.18 7.887-1.668 10.465-.43 2.277-1.958 1.292-3.338.397-1.296-.84-2.028-1.362-3.286-2.182-1.453-.947-.511-1.467.317-2.318.217-.223 3.984-3.61 4.057-3.918.06-.256-.167-.333-.373-.286-.13.029-2.2 1.382-6.21 4.058-.588.399-1.12.593-1.597.583-.66-.014-2.26-.583-3.88-1.492-.097-.277.399-.53 1.096-.804z"
                  fill="currentColor" />
                </svg>
                <span className={styles.tierButtonText}>Написать в Telegram</span>
                <span className={styles.tierButtonArrow} aria-hidden="true">→</span>
              </a>
            </div>
          </div>
          <div className={styles.heroImageContainer}>
            <div className={styles.cardScanline} aria-hidden="true" />
            <div className={styles.cardCornerTL} aria-hidden="true" />
            <div className={styles.cardCornerBR} aria-hidden="true" />
            <EventTimelineChart />
          </div>
        </div>
      </section>
      {lightboxOpen && (
        <ImageLightbox
          src={lineImage}
          alt="Книжный клуб"
          onClose={() => setLightboxOpen(false)}
        />
      )}
    </>
  );
};
